"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var sis_photo_capture_popup_component_1 = require("./sis-photo-capture-popup.component");
var ngx_webcam_1 = require("ngx-webcam");
var document_service_1 = require("../../document.service");
var index_1 = require("../../model/index");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var subscription_manager_decorator_1 = require("../../shared/subscription-manager.decorator");
var operators_1 = require("rxjs/operators");
var PhotoCaptureComponent = /** @class */ (function () {
    function PhotoCaptureComponent(dialog, documentService) {
        this.dialog = dialog;
        this.documentService = documentService;
        this.height = 240;
        this.photoUpdate = new core_1.EventEmitter();
        this.photoRemove = new core_1.EventEmitter();
        this.metaData = null;
        this.hasCamera = this.hasAnyCamera();
    }
    PhotoCaptureComponent_1 = PhotoCaptureComponent;
    PhotoCaptureComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.documentId) {
            this.$sm = this.documentService.getTempDocumentUrl(this.documentId, index_1.FileType.ORIGINAL)
                .subscribe(function (url) {
                _this.imageUrl = url;
                console.log('url', JSON.stringify(url));
            });
        }
    };
    /*
        TODO confirm changes
    */
    PhotoCaptureComponent.prototype.openCapturePopup = function () {
        var _this = this;
        var capturePopup = this.dialog.open(sis_photo_capture_popup_component_1.CapturePopup, { data: { imageType: PhotoCaptureComponent_1.IMAGE_TYPE } });
        capturePopup.afterClosed().subscribe(function (image) {
            if (image) {
                _this.imageUrl = image.imageAsDataUrl;
                var file_1 = PhotoCaptureComponent_1.convertImageToFile(image);
                _this.$sm = _this.documentService.validate(file_1).pipe(operators_1.switchMap(function () {
                    return _this.documentService.upload(_this.categoryId, file_1.name, file_1, _this.metaData);
                })).subscribe(function (document) {
                    _this.photoUpdate.emit(document.id);
                });
            }
        });
    };
    PhotoCaptureComponent.prototype.deletePhoto = function () {
        this.imageUrl = null;
        this.photoRemove.emit(this.documentId);
    };
    PhotoCaptureComponent.convertImageToFile = function (image) {
        var decoded = atob(image.imageAsBase64);
        var length = decoded.length;
        var arr = new Uint8Array(length);
        for (var i = 0; i < length; i++) {
            arr[i] = decoded.charCodeAt(i);
        }
        return new File([arr], "photo" + this.nextPhotoId++ + "." + this.IMAGE_TYPE, { type: "image/" + this.IMAGE_TYPE });
    };
    PhotoCaptureComponent.prototype.hasAnyCamera = function () {
        return ngx_webcam_1.WebcamUtil.getAvailableVideoInputs().then(function (value) {
            return value.length !== 0;
        });
    };
    PhotoCaptureComponent.IMAGE_TYPE = "jpeg";
    PhotoCaptureComponent.nextPhotoId = 0;
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PhotoCaptureComponent.prototype, "imageUrl", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PhotoCaptureComponent.prototype, "categoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], PhotoCaptureComponent.prototype, "documentId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PhotoCaptureComponent.prototype, "photoUpdate", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], PhotoCaptureComponent.prototype, "photoRemove", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Map)
    ], PhotoCaptureComponent.prototype, "metaData", void 0);
    PhotoCaptureComponent = PhotoCaptureComponent_1 = __decorate([
        core_1.Component({
            
            selector: "sis-photo-capture",
            template: require('./sis-photo-capture.component.html'),
            styles: [require('./sis-photo-capture.component.css')]
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "\n\t\t<sis-photo-capture\n        [categoryId]=\"category\"\n        [documentId]=\"%{field}\"\n        (photoUpdate)=\"%{photoUpdate}\"\n        (photoRemove)=\"%{photoRemove}\">\n\t\t</sis-photo-capture>",
            name: "PhotoCaptureComponent",
            defaultActions: {
                'photoUpdate': 'submitDocument',
                'photoRemove': 'removeDocument'
            }
        }),
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [material_1.MatDialog,
            document_service_1.DocumentService])
    ], PhotoCaptureComponent);
    return PhotoCaptureComponent;
    var PhotoCaptureComponent_1;
}());
exports.PhotoCaptureComponent = PhotoCaptureComponent;
//# sourceMappingURL=sis-photo-capture.component.js.map